import React from "react";
import { themeStyle, themeStyleDark } from "./Components";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useNavigate } from "react-router-dom";

export default function Footer(props) {
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  return (
    <div
      className="footer"
      style={{
        backgroundColor: "black",
        padding: "50px",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.primaryColor
            : themeStyle.primaryColor,
      }}
    >
      <Grid container spacing={5}>
        <Grid
          item
          md={3}
          style={{
            height: "100%",
            width: "100%",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "20px" : "30px",
              fontFamily: "Montserrat",
              color: "white",
              fontWeight: "bold",
            }}
          >
            SLV INTERNATIONAL SCHOOL
          </div>
          <div
            style={{
              fontSize: "20px",
              fontFamily: "Montserrat",
              color: "white",
              marginBottom: "50px",
            }}
          >
            SY. NO.24, Channarayapattana road, Vijayapura, Devanahalli TQ,
            Bangalore Rural Karnataka 562135
          </div>
        </Grid>

        <Grid
          item
          md={3}
          style={{
            height: "100%",
            width: "100%",
          }}
        >
          {" "}
          <div
            onClick={() => {
              navigate("/about_school");
            }}
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              color: "white",
              cursor: "pointer",
            }}
          >
            About School
          </div>
          <div
            onClick={() => {
              navigate("/about_chairman");
            }}
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              color: "white",
              cursor: "pointer",
            }}
          >
            About Chairman
          </div>
          <div
            onClick={() => {
              navigate("/about_principal");
            }}
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              color: "white",
              cursor: "pointer",
            }}
          >
            About Principal
          </div>
          <div
            onClick={() => {
              navigate("/overview");
            }}
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              color: "white",
              cursor: "pointer",
            }}
          >
            Admissions
          </div>
        </Grid>
        <Grid
          item
          md={3}
          style={{
            height: "100%",
            width: "100%",
          }}
        >
          {" "}
          <div
            onClick={() => {
              navigate("/about_school");
            }}
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              color: "white",
              cursor: "pointer",
            }}
          >
            SLVIS
          </div>
          <div
            onClick={() => {
              navigate("/registration");
            }}
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              color: "white",
              cursor: "pointer",
            }}
          >
            Apply Now
          </div>
          <div
            onClick={() => {
              navigate("/contact");
            }}
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              color: "white",
              cursor: "pointer",
            }}
          >
            Contact Us
          </div>
          <div
            onClick={() => {
              navigate("/facilities");
            }}
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              color: "white",
              cursor: "pointer",
            }}
          >
            Facilities
          </div>
        </Grid>
        <Grid
          item
          md={3}
          style={{
            height: "100%",
            width: "100%",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              style={{
                border: "2px white solid",
                borderRadius: "40px",
                width: "70px",
                height: "70px",
                fontSize: "20px",
                color: "white",
              }}
            >
              <EmailIcon style={{ color: "white", fontSize: "40px" }} />
            </Button>
            <Button
              onClick={() => {
                navigate(
                  "https://www.facebook.com/share/15cPJreDDM/?mibextid=wwXIfr"
                );
              }}
              style={{
                border: "2px white solid",
                borderRadius: "40px",
                width: "70px",
                height: "70px",
                fontSize: "20px",
                color: "white",
              }}
            >
              <FacebookIcon style={{ color: "white", fontSize: "40px" }} />
            </Button>
            <Button
              onClick={() => {
                navigate(
                  "https://www.instagram.com/slv_international_school?igsh=MTduMjNvMmdjZ3FrYQ=="
                );
              }}
              style={{
                border: "2px white solid",
                borderRadius: "40px",
                width: "70px",
                height: "70px",
                fontSize: "20px",
                color: "white",
              }}
            >
              <InstagramIcon style={{ color: "white", fontSize: "40px" }} />
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
